import { render, staticRenderFns } from "./ImportExcelToJsonCard.vue?vue&type=template&id=1aa3852a&scoped=true&"
import script from "./ImportExcelToJsonCard.vue?vue&type=script&lang=js&"
export * from "./ImportExcelToJsonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3852a",
  null
  
)

export default component.exports